import { Map, Record } from 'immutable';

import {
	CharacteristicType,
	DcTimestampFormat,
} from '../../core/dc-core-types';
import { AvailableVersionEntity } from '../components/change-version-modal/available-version.entity';
import { DepotHeaderListEntity } from '../components/create-entity-from-depot-modal/depot-header-list.entity';
import { DepotListEntity } from '../components/depot-list/depot-list.entity';
import { DepotSchemaEntity } from '../components/depot-schema-viewer/depot-schema.entity';
import { SupportedLanguageEntity } from '../domain/supported-language.entity';

export const DepotSliceKey = 'main';

export interface IDepotOriginalSliceState {
	loading: boolean;
	actionInProgress: boolean;
	list: DepotListEntity;
	headersForSelectRepo: DepotHeaderListEntity;
	depotSchema: Array<DepotSchemaEntity> | null;
	availableCharacteristicTypes: Map<number, CharacteristicType>;
	availableDateFormats: Map<string, DcTimestampFormat>;
	availableTimezones: Array<string>;
	supportedLanguages: Map<string, SupportedLanguageEntity>;
	availableVersionsForSelectedDataLinkRepo: Map<number, AvailableVersionEntity>;
}

const defaults: IDepotOriginalSliceState = {
	loading: false,
	actionInProgress: false,
	list: DepotListEntity.build([]),
	headersForSelectRepo: DepotHeaderListEntity.build([]),
	depotSchema: null,
	availableCharacteristicTypes: Map(),
	availableDateFormats: Map(),
	availableTimezones: [],
	supportedLanguages: Map(),
	availableVersionsForSelectedDataLinkRepo: Map(),
};

export class DepotOriginalSliceState extends Record<IDepotOriginalSliceState>(
	defaults
) {
	public static readonly key = DepotSliceKey;

	public setLoading(isLoading: boolean): DepotOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setActionInProgress(
		isActionInProgress: boolean
	): DepotOriginalSliceState {
		return this.set('actionInProgress', isActionInProgress);
	}

	public setDepotList(depotList: DepotListEntity): DepotOriginalSliceState {
		return this.set('list', depotList);
	}

	public setHeadersForSelectRepo(
		headersForSelectRepo: DepotHeaderListEntity
	): DepotOriginalSliceState {
		return this.set('headersForSelectRepo', headersForSelectRepo);
	}

	public setDepotSchema(
		val: Array<DepotSchemaEntity> | null
	): DepotOriginalSliceState {
		return this.set('depotSchema', val);
	}

	public setAvailableCharacteristicTypes(
		types: Map<number, CharacteristicType>
	): DepotOriginalSliceState {
		return this.set('availableCharacteristicTypes', types);
	}

	public setAvailableDateFormats(
		dateFormats: Map<string, DcTimestampFormat>
	): DepotOriginalSliceState {
		return this.set('availableDateFormats', dateFormats);
	}

	public setAvailableTimezones(val: Array<string>): DepotOriginalSliceState {
		return this.set('availableTimezones', val);
	}

	public setSupportedLanguages(
		val: Map<string, SupportedLanguageEntity>
	): DepotOriginalSliceState {
		return this.set('supportedLanguages', val);
	}

	public setAvailableVersionsForSelectDataLinkRepo(
		val: Map<number, AvailableVersionEntity>
	): DepotOriginalSliceState {
		return this.set('availableVersionsForSelectedDataLinkRepo', val);
	}

	public deleteHeadersForState(): DepotOriginalSliceState {
		return this.set('headersForSelectRepo', defaults.headersForSelectRepo);
	}
}
